export default __webpack_public_path__ + "static/media/duriation_icon.a271bac4.svg";